// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3Fdzs","inner":"Footer_inner__1fRzD","nextIcon":"Footer_nextIcon__1ySDb","innerLeft":"Footer_innerLeft__14XWX"};